export const settingConsts = {
  LOAD_REQUEST: '[Settings] LOAD_REQUEST',
  LOAD_FAILURE: '[Settings] LOAD_FAILURE',
  LOAD_SUCCESS: '[Settings] LOAD_SUCCESS'
};
